import React, { useState } from 'react';
import toast from 'react-hot-toast';
import {
    Grid,
    Button,
    Box,
    Typography,
} from '@mui/material';
import { Input, CommonModal } from '../../Common';
import Routes from '../../../routes';
import { trakrefBlue } from '../../../color_utils';

const CloseWorkOrderModal = ({
    payload,
    modalOpen,
    onClose,
    refreshRequired
}) => {
    const [laborCost, setLaborCost] = useState(null);
    const [otherCost, setOtherCost] = useState(null);
    const [materialCost, setMaterialCost] = useState(null);

    const confirmCloseWorkOrder = async () => {
        const postConfig = {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                ID: payload.ID,
                LaborCost: laborCost,
                MaterialCost: materialCost,
                OtherCost: otherCost
            })
        };

        const UpdateResponse = await fetch(Routes.WorkOrder.CloseWorkOrder(), postConfig);
        console.log(UpdateResponse);

        if (UpdateResponse.status === 200) {
            onClose();
            toast.success('Work order successfully closed', { duration: 6000 });
            refreshRequired();
        } else {
            onClose();
            const error = await UpdateResponse.json();
            if (Array.isArray(error) && error[0] !== undefined) {
                toast.error(error[0].exceptionMessage , { duration: 6000 });
            }
        }
    };

    return (
        <CommonModal
            open={modalOpen}
            close={onClose}
            header={`Close Work Order #${payload.ID}?`}
        >
            <Grid container sx={{ px: { xs: 1, sm: 10 } }}>
                <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                    <Input
                        fullWidth
                        variant="outlined"
                        label="Labor Cost"
                        type={'number'}
                        value={laborCost}
                        onChange={e => setLaborCost(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                    <Input
                        fullWidth
                        variant="outlined"
                        label="Other Cost"
                        value={otherCost}
                        onChange={e => setOtherCost(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                    <Input
                        fullWidth
                        variant="outlined"
                        label="Material Cost"
                        value={materialCost}
                        onChange={e => setMaterialCost(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} lg={12} mb={2} pt={2} align='left'>
                    <Typography sx={{ padding: '1% 0%', fontSize: 17, fontWeight: 600 }}>
                        Total Cost ($) : ${+parseInt(laborCost || 0)  + +parseInt(otherCost || 0) + +parseInt(materialCost | 0) }
                    </Typography>
                </Grid>
                <Grid item xs={12} lg={12} align='center'>
                    <Box mt={2} mb={2} sx={{ width: '100%' }}>
                        <Button
                            fullWidth
                            size='large'
                            variant='contained'
                            onClick={confirmCloseWorkOrder}
                            style={{
                                backgroundColor: trakrefBlue
                            }}
                        >
                            <Typography sx={{ padding: '1% 0%', color: '#fff', fontSize: 17, fontWeight: 400 }}>
                                CLOSE WORK ORDER
                            </Typography>
                        </Button>
                    </Box>
                </Grid>

            </Grid>
        </CommonModal>
    );
};

export default CloseWorkOrderModal;
